import linkFor from "./linkFor";

const returnPath = (query, { fallback } = {}) => {
  const { returnPath: path } = query;
  if (path && path.match(/^\/[a-z0-9_-]+/)) {
    return path;
  } else if (fallback) {
    return fallback;
  } else {
    return linkFor("dashboard");
  }
};

export default returnPath;
